import React from 'react';
import Toolkit from '../../../common/utils/toolkit'

export default Component =>
  class GeolocatedContainer extends React.Component {
    _geocoderRequested = false;

    state = {
      geolocation: null,
    };

    componentDidMount() {
      Toolkit.log('Toolkit Logging componentDidMount');
    
      function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`);
      }
      // you can never be too sure about anything in javascript
      if (
        window &&
        window.navigator &&
        window.navigator.geolocation &&
        typeof window.navigator.geolocation.getCurrentPosition === 'function'
      ) {
        window.navigator.geolocation.getCurrentPosition(position => {
          Toolkit.log('Position found '+this.geocode);
        
          this.setState({ geolocation: position.coords }, this.geocode);
        },error);
      }
    }

    geocode() {
      if (!this.state.geolocation || this._geocoderRequested) {
        return;
      }
      this._geocoderRequested = true;
      const { latitude: lat, longitude: lon } = this.state.geolocation;
      const url =
        'https://nominatim.openstreetmap.org/reverse' +
        '?format=json' +
        '&lat=' +
        encodeURIComponent(lat) +
        '&lon=' +
        encodeURIComponent(lon) +
        '&zoom=5' +
        '&addressdetails=1';

      fetch(url)
        .then(resp => {
          if (!resp.ok) {
            const err = new Error('nominatim failed: ' + resp.status);
            err.status = resp.status;
            throw err;
          }
          return resp.json();
        })
        .then(json => {
          const state =
            (json && json.address && json.address.state) ||
            (json && json.address && json.address['ISO3166-2-lvl4']) ||
            '';
          if (!state) {
            return;
          }
          this.setState(prevState => ({
            geolocation: {
              ...prevState.geolocation,
              state,
            },
          }));
        })
        .catch(err => {
          var status = err && err.status;
          if (status === 429) {
            console.warn('[withGeolocated] Nominatim rate limited (429)');
          } else {
            console.warn('[withGeolocated] Nominatim request failed', err);
          }
        });
    }

    render() {
      return <Component {...this.state} {...this.props} />;
    }
  };



// WEBPACK FOOTER //
// ./src/App/events/components/withGeolocated.js